import { useTranslation } from "react-i18next";
import { PMSLocation } from "../../_models/PMSLocation";
import { EARLY_CHECKIN_STATE_BADGE } from "../../_models/PMSIntegration";
import { CustomCard, CaptionText } from "../../../Everou/_components";
import { Icons } from "../../../Everou/_assets";
import { DEVICE_TYPES } from "../../../Everou/_constants";
import iconProtectOn from "../../../Everou/_assets/appIcons/icon_protect_on.svg";


export function PMSLocationView({
    location = PMSLocation(),
    handleSelectPMSLocation = () => {},
    isSelected = false,
}) {
    const { t } = useTranslation();

    return (
        <CustomCard
            data-testid={location.uid}
            selected={isSelected}
            onClick={handleSelectPMSLocation}
            key={location.uid}
            banner={activeReservationStatus()}
            className="h-100"
            bannerBackground={activeReservationBackground()}
        >
            <div className="c-line-height-1 ml-2 c-mt-05 w-100">
                <div>
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="c-line-height-1 mb-0">
                            {location.name}
                            {location.id != null &&
                                <small className="text-muted ml-1">({location.id})</small>
                            }
                        </h3>
                        {location.hasIntegration === false &&
                            <span className="badge badge-warning ml-2 flex-shrink-0">
                                {t("mod_pms_location_no_pms_badge")}
                            </span>
                        }
                        {location.pendingEarlyCheckinCount > 0 &&
                            <span
                                className="badge badge-pill ml-2 flex-shrink-0"
                                style={{
                                    backgroundColor: EARLY_CHECKIN_STATE_BADGE.requested.color,
                                    color: "#fff",
                                    textTransform: "none",
                                }}
                                title={t("mod_pms_location_pending_early_checkin_tooltip", {
                                    count: location.pendingEarlyCheckinCount,
                                })}
                            >
                                {t("mod_pms_location_pending_early_checkin_badge")}
                                {location.pendingEarlyCheckinCount > 1 &&
                                    ` · ${location.pendingEarlyCheckinCount}`}
                            </span>
                        }
                        {location.hasIntegrationError &&
                            <span
                                className="ml-2 flex-shrink-0"
                                role="img"
                                aria-label="warning"
                                title={t("mod_pms_location_integration_error")}
                            >
                                ⚠️
                            </span>
                        }
                    </div>
                    <div className="d-flex align-items-center mt-2">
                        <small style={{color: location.reservations? "#009FDF": "#828282"}}>{location.reservations? location.reservations:0}</small>
                        <img
                            className={`${
                                "c-img-1-25rem"
                            }`}
                            src={location.reservations > 0? Icons.icon_reservations: Icons.icon_no_reservations}
                        />
                        {hasWifiDevices() &&
                            <div className="pl-2">
                                {disconnectedDevices() ?
                                    <img
                                        className={`${
                                            "c-img-1-25rem"
                                        }`}
                                        src={Icons.wifi_no_connection}
                                    />
                                    :
                                    <img
                                        className={`${
                                            "c-img-1-25rem"
                                        }`}
                                        src={Icons.wifi_connection}
                                    />
                                }
                                
                            </div>
                        }
                        {hasLockDevices() &&
                            getLockBattery()
                        }
                        {location.protectStatus &&
                            <div className="pl-2">
                                <img
                                    className="c-img-1-25rem"
                                    src={iconProtectOn}
                                    alt="protect"
                                    title={t("mod_pms_location_auto_protect_status_armed")}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </CustomCard>
    );

    function disconnectedDevices() {
        return location.hasDisconnectedDevices;
    }

    function hasWifiDevices() {
        return location.hasWifiDevices;
    }

    function hasLockDevices() {
        return location.hasLockDevices;
    }

    function getLockBattery() {
        return (
            <div className="pl-2">
                <small style={{color: location.deviceBattery<=30? "red": "#828282"}}>{location.deviceBattery}%</small>
                <img
                    className={`${"c-img-1-25rem"}`}
                    src={location.deviceBattery <= 30 ? Icons.battery_low:Icons.battery}
                    />
            </div> 
            
        )
    }

    function activeReservationStatus() {
        if (!location.hasActiveReservation)
            return null;

        return (
            <div
                className="
                    text-right
                    text-white
                    c-line-height-1rem
                "
            >
                {t("mod_pms_active_reservation")}
            </div>
        );
    }

    function activeReservationBackground() {
        return location.hasActiveReservation ? "#009FDF" : "";
    }
}